import {
  Button,
  ModalGeneric,
  ModalWrapper,
  ModalWrapperProps,
  styled,
} from '@payright/web-components';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../reducers';
import { checkoutCancellation } from '../../reducers/checkout-slice';
import { AppThunkDispatch } from '../../util/store';
import { useQuery } from '../../util/hooks';
import SCSpinner from '../spinner';
import getConstants from '../../util/constants';
import { AlertSliceError } from '../alert-slice-error';

const { REDIRECT_URL } = getConstants();

type ModalCancelPlanProps = Pick<ModalWrapperProps, 'handleClose'> & {};

type ModalContentProps = {
  hasErrors: boolean;
  errorMessage: string | null | undefined;
};

const SCModalContent = styled.article`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  width: 100%;
  max-width: 25rem;
`;

const ModalContent = ({ hasErrors, errorMessage }: ModalContentProps) => {
  return (
    <SCModalContent>
      {hasErrors && (
        <AlertSliceError
          slice={{
            hasErrors,
            errorMessage,
          }}
        />
      )}
      <p>Do you want to cancel your BNPL application?</p>
    </SCModalContent>
  );
};

export const ModalCancelPlan = ({ handleClose }: ModalCancelPlanProps) => {
  const query = useQuery();
  const checkoutId = query.get('checkoutId')!;

  const dispatch = useDispatch<AppThunkDispatch>();

  const { loading, checkout, hasErrors, errorMessage } = useSelector(
    (state: RootState) => state.checkout
  );
  const isCancellingPlan = useSelector((state: RootState) =>
    state?.checkout?.activeRequests?.includes('checkoutCancellation')
  );

  const areButtonsDisabled = loading || isCancellingPlan;

  const handleCancel = async () => {
    const cancelled = await dispatch(checkoutCancellation(checkoutId));

    if (!cancelled) {
      return;
    }

    const redirectUrl = checkout?.attributes?.redirectUrl || REDIRECT_URL;
    const separator = redirectUrl.indexOf('?') === -1 ? '?' : '&';
    window.location.replace(`${redirectUrl}${separator}checkoutId=${checkoutId}&status=CANCEL`);
  };

  return (
    <ModalWrapper open={true} handleClose={handleClose} background="dark">
      <ModalGeneric
        title={'Are you sure?'}
        content={<ModalContent hasErrors={hasErrors} errorMessage={errorMessage} />}
        primaryButton={
          <Button
            handleClick={handleCancel}
            disabled={areButtonsDisabled}
            icon={isCancellingPlan ? <SCSpinner /> : undefined}
          >
            Yes
          </Button>
        }
        secondaryButton={
          <Button
            outline
            colour="blue"
            handleClick={handleClose}
            testId="button-close"
            disabled={areButtonsDisabled}
          >
            No
          </Button>
        }
      />
    </ModalWrapper>
  );
};
